import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-4" }
const _hoisted_2 = { class: "flex flex-col gap-4 flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_UploadFile = _resolveComponent("UploadFile")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Title, {
      class: "mb-4",
      label: _ctx.$t('clientManagement.managementDetail.tabs.cooperationAgreement'),
      fontSize: 20
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.startedFrom'),
          asterisk: "",
          fontSize: 14
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DatePicker, {
              placeholder: _ctx.$t('clientManagement.registrationForm.agreement.selectStartDate'),
              class: "mt-2",
              modelValue: _ctx.formModel.startDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formModel.startDate = $event))
            }, null, 8, ["placeholder", "modelValue"]),
            (_ctx.invalidDate)
              ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("clientManagement.registrationForm.agreement.invalidDate")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.until'),
          asterisk: "",
          fontSize: 14
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DatePicker, {
              placeholder: _ctx.$t('clientManagement.registrationForm.agreement.selectEndDate'),
              class: "mt-2",
              modelValue: _ctx.formModel.endDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formModel.endDate = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('clientManagement.managementDetail.frpDocument'),
        asterisk: "",
        fontSize: 14,
        class: "flex-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UploadFile, {
            titleChange: _ctx.$t('clientManagement.registrationForm.agreement.changeFile'),
            type: "",
            modelValue: _ctx.formModel.attachment,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formModel.attachment = $event)),
            caption: ".pdf up to 16 MB",
            allowed: ".pdf",
            customClass: "py-5",
            maxSize: 16,
            isDraggable: false,
            url: _ctx.formModel.attachmentUrl,
            name: _ctx.formModel.fileNameAttachment,
            longName: 40,
            onChange: _cache[4] || (_cache[4] = 
            () => {
              _ctx.formModel.fileNameAttachment = '';
              _ctx.formModel.attachmentUrl = '';
            }
          ),
            onError: _cache[5] || (_cache[5] = 
            (error) => {
              _ctx.formErrorModel.documentFrp = error
            }
          ),
            onUpdateFilename: _cache[6] || (_cache[6] = () => {
            _ctx.formModel.fileNameAttachment = '';
            _ctx.formModel.attachmentUrl = '';
          }),
            isClearable: ""
          }, null, 8, ["titleChange", "modelValue", "url", "name"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('clientManagement.managementDetail.pksDocument'),
        fontSize: 14,
        class: "flex-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UploadFile, {
            id: _ctx.routeTypeName === 'edit-client-parent' ? 'upload_pks_edit_client_parent' : 'upload_pks_create_client_parent',
            titleChange: _ctx.$t('clientManagement.registrationForm.agreement.changeFile'),
            type: "",
            modelValue: _ctx.formModel.pksAttachment,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formModel.pksAttachment = $event)),
            caption: ".pdf up to 16 MB",
            allowed: ".pdf",
            customClass: "py-5",
            maxSize: 16,
            isDraggable: false,
            url: _ctx.formModel.pksAttachmentUrl,
            name: _ctx.formModel.pksAttachmentName,
            longName: 40,
            onCancel: _cache[8] || (_cache[8] = 
            () => {
              _ctx.formModel.isUpdatePksAttachment = false;
            }
          ),
            onChange: _cache[9] || (_cache[9] = 
            () => {
              _ctx.formModel.pksAttachmentUrl = '';
              _ctx.formModel.pksAttachmentName = '';
              _ctx.formModel.isUpdatePksAttachment = true;
            }
          ),
            onError: _cache[10] || (_cache[10] = 
            (error) => {
              _ctx.formErrorModel.documentPks = error
            }
          ),
            onUpdateFilename: _cache[11] || (_cache[11] = () => {
            _ctx.formModel.pksAttachmentUrl = '';
            _ctx.formModel.pksAttachmentName = '';
            _ctx.formModel.isUpdatePksAttachment = true;
          }),
            isClearable: ""
          }, null, 8, ["id", "titleChange", "modelValue", "url", "name"])
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
}